<article
  class="col-span-12 relative w-full"
  [class.text-white]="isTextColorWhite"
  [class.text-black]="!isTextColorWhite"
>
  <app-picture
    [image]="banner.imageDesktop"
    [imageMobile]="banner.imageMobile"
    [isFullImage]="true"
    classNamePicture=""
    classNameImage="w-full aspect-square md:aspect-[16/9] object-cover"
    [isHp]="isHp"
  ></app-picture>
  <!-- bg-light-black-gradient -->
  <div
    class="absolute top-0 left-0 w-full h-full bg-custom-banner"
    [class.bg-light-black-gradient]="isTextColorWhite"
    [class.bg-black-light-gradient]="!isTextColorWhite"
  ></div>
  <div
    class="absolute top-0 right-0 left-0 flex flex-col justify-end items-center w-10/12 lg:w-2/3 h-full mx-auto pb-2xl lg:pb-5xl text-center font-regular font-semibold"
  >
    <h2
      class="w-10/12 lg:w-2/3 lg:text-banner text-2xl lg:leading-banner pl-2xl 2xl:pl-9xl first-letter:-ml-2xl 2xl:first-letter:-ml-9xl"
    >
      {{ banner.title }}
    </h2>
    <div
      *ngIf="banner.description"
      class="mb-l lg:mb-2xl"
      [innerHtml]="banner.description"
    ></div>
    <ng-container *ngFor="let link of banner.links">
      <a
        app-vtmn-play-button
        class="mt-xl lg:mt-2xl"
        [class.w-full]="isMobileDevice"
        [shape]="
          isMobileDevice
            ? vtmnPlayButtonShape.SQUARED
            : vtmnPlayButtonShape.ROUNDED
        "
        [href]="link.url || link.externalUrl"
        [target]="link.openInNewTab ? '_blank' : '_self'"
        [rel]="link.openInNewTab ? 'noopener noreferrer' : null"
        [attr.aria-label]="link.text"
      >
        {{ link.text }}
      </a>
    </ng-container>
  </div>
</article>
